<template>
  <el-table
    id="assignedproductstable"
    :data="productsList"
    style="width: 100%"
    :header-cell-style="headerstyle"
    :row-style="rowdatastyle"
    @selection-change="handleSelectionChange"
    :cell-class-name="checkExpirationDate"
    empty-text="No products assigned"
    v-loading="loading"
    :row-class-name="getRowClassName"
  >
    <el-table-column type="selection" width="55" :selectable="checkSelectable">
    </el-table-column>
    <el-table-column label="Assigned Products" prop="productName">
      <template #default="props">
        <div class="prodcelldiv">
          <img
            src="@/assets/icons/vcicon.svg"
            class="cellimage"
            alt="vciconimg"
            title="vciconimg"
          />
          <div class="celltext">
            <label style="margin: unset">{{
              props.row.productName.substring(0, 18)
            }}</label>
            <label style="font-weight: 700">{{
              props.row.productName.substring(18)
            }}</label>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="Version" width="80">
      <template #default="props">
        {{ props.row.majorVersionNumber }}.{{ props.row.minorVersionNumber }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="License Type" prop="licenseType">
    </el-table-column>
    <el-table-column label="Computer ID" prop="computer"> </el-table-column>
    <el-table-column label="Product Status" prop="support" align="center">
      <template #default="prod">
        <div class="borrowcell">
          <img
            :src="getStatus(prod.row).icon"
            :alt="getStatus(prod.row).icon + 'iconimg'"
            :title="getStatus(prod.row).icon + 'iconimg'"
          />
          <label style="margin-left: 5px">{{
            getStatus(prod.row).label
          }}</label>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Add-on" align="center" prop="addOns">
      <template #default="props">
        <div v-for="(addon, index) in props.row.addOns" :key="index">
          {{ addon.productName }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Expiration Date" align="center">
      <template #default="props">
        <el-tooltip
          placement="top"
          v-if="checkExpirationDate(props.row.expirationDateTime)"
        >
          <template #content>
            <div v-if="expiringIn30Days">
              The license has expired or is about to expire shortly.
              <br />Please unassign the expired license and assign the new
              license.
            </div>
          </template>
          <div class="expiration-cell">{{ props.row.expirationDate }}</div>
        </el-tooltip>
        <div v-if="!checkExpirationDate(props.row.expirationDateTime)">
          {{ props.row.expirationDate }}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="Maintenance Renewal Date"
      prop="maintenanceRenewalDateFormatted"
    >
    </el-table-column>
  </el-table>
</template>

<style lang="scss">
.prodcelldiv {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 0;
}
.expiration-cell {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #df444d;
}
.el-table .disabled-row .el-checkbox__input .el-checkbox__inner {
  cursor: not-allowed;
  background-color: rgba(172, 179, 180, 0.5);
  border-color: rgba(172, 179, 180, 0.5);
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import APIService from "@/utils/APIService";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { UserActionTypes } from "@/store/userstore/UserActionTypes";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";
import { UserProductsViewModel } from "@/utils/AppInterfaces";

export default defineComponent({
  name: "AssignedProducts",
  components: {},
  computed: {
    ...mapGetters(["getUserData", "getAssProdList"]),
    productsList(): any {
      return this.getAssProdList.items;
    },
  },
  data() {
    return {
      headerstyle: {
        "border-bottom": "unset",
        background: "#F2F2F2",
        "font-family": "Open Sans, sans-serif",
        "font-weight": "700",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      rowdatastyle: {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "400",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      multipleSelection: [],
      expiringIn30Days: false,
      loading: true,
    };
  },
  methods: {
    getAssignedProducts() {
      const apiService = new APIService(this.axios);
      const userDataObj = {
        userBucketIdList: [this.getUserData.userBucketId],
        pageOptions: {
          sortOrder: 0,
        },
      };
      apiService
        .getAssignedProdsList(userDataObj)
        .then((res) => {
          this.$store.dispatch(UserActionTypes.SET_ASSIGNED_PRODUCTS, res);
          this.loading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
          this.loading = false;
        });
    },
    handleSelectionChange(selected: any) {
      this.multipleSelection = selected;
      var addonProducts = [] as any[];
      selected.map((item: any) => {
        if (item.addOns.length !== 0) addonProducts = item.addOns;
      });
      this.$store.dispatch(FlowActionTypes.SET_ADDON_PRODUCTS, addonProducts);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_PRODUCTS, selected);
    },
    checkExpirationDate(expiringDate: any) {
      const expirationDate = new Date(expiringDate);
      const dateIn30Days = new Date();

      // Add 30 days correctly
      dateIn30Days.setDate(dateIn30Days.getDate() + 30);

      if (expirationDate.getTime() <= dateIn30Days.getTime()) {
        return (this.expiringIn30Days = true);
      }
      return false;
    },
    getStatus(item: UserProductsViewModel) {
      if (item.entitlementBorrowed === true) {
        return {
          icon: require("@/assets/icons/borrowed.svg"),
          label: "Borrowed",
          rowDisabled: true,
        };
      } else if (item.active === true) {
        return {
          icon: require("@/assets/icons/active.svg"),
          label: "Activated",
          rowDisabled: false,
        };
      } else {
        return {
          icon: require("@/assets/icons/inactive.svg"),
          label: "Not Activated",
          rowDisabled: false,
        };
      }
    },
    getRowClassName({ row }: { row: UserProductsViewModel }) {
      const status = this.getStatus(row);
      return status?.rowDisabled ? "disabled-row" : "";
    },
    checkSelectable(row: UserProductsViewModel) {
      const status = this.getStatus(row);
      return status?.rowDisabled ? false : true;
    },
  },
  mounted() {
    this.getAssignedProducts();
  },
});
</script>
